import * as z from "zod";
import { merchantSubmissionStatusSchema } from "./get-merchant-submissions";

export const updateMerchantSubmissionStatus = {
  name: "updateMerchantSubmissionStatus" as const,
  input: z.object({
    submissionId: z.string().regex(/^\d+$/),
    status: merchantSubmissionStatusSchema,
  }),
  output: z.object({ success: z.literal(true) }),
};
